import React from 'react';
import {SvgIcon, SvgIconProps} from '@mui/material';

const scalingSpacesPath = 'M31 28L26 34L24 40L24 103L88 103L96 99L101 93L103 88L103 24L40 24L39 25L36 25ZM27 69L28 68L59 99L58 100L28 100L27 99ZM68 28L69 27L99 27L100 28L100 58L99 59ZM33 30L39 27L47 27L52 29L98 75L100 80L100 88L99 91L94 97L88 100L80 100L75 98L29 52L27 47L27 39L28 36Z';

export default function ScalingSpacesIcon({colored = false, ...props}: {
    colored?: boolean;
} & SvgIconProps) {
    return (
        <SvgIcon {...props} viewBox="16 16 96 96">
            <path
                fillRule="evenodd"
                d={scalingSpacesPath}
                fill={colored ? '#000' : 'currentColor'}
            />
        </SvgIcon>
    );
}
